import * as React from "react";
const SvgFiRrEarMuffs = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ear-muffs_svg__a)">
      <path
        fill="#062147"
        d="M24 16.525a2.96 2.96 0 0 0-.592-1.777q.092-.355.092-.723a3.004 3.004 0 0 0-2.33-2.924A3.2 3.2 0 0 0 20 9.784V8c0-4.411-3.589-8-8-8S4 3.589 4 8v1.784a3.2 3.2 0 0 0-1.17 1.318A3.004 3.004 0 0 0 .5 14.026q0 .367.092.723A2.96 2.96 0 0 0 0 16.526c0 .675.23 1.323.639 1.846a3.006 3.006 0 0 0 2.191 3.829 3.23 3.23 0 0 0 2.92 1.825A3.254 3.254 0 0 0 9 20.776v-8.25c0-1.706-1.326-3.095-3-3.225V8c0-3.309 2.691-6 6-6s6 2.691 6 6v1.301c-1.674.13-3 1.518-3 3.225v8.25a3.254 3.254 0 0 0 3.25 3.25 3.23 3.23 0 0 0 2.92-1.825 3.006 3.006 0 0 0 2.191-3.829A3 3 0 0 0 24 16.525m-17-4v8.25c0 .689-.561 1.25-1.25 1.25a1.24 1.24 0 0 1-1.216-.976 1 1 0 0 0-.975-.78c-.644-.02-1.059-.456-1.059-.994 0-.2.06-.395.172-.561a1 1 0 0 0-.249-1.377.99.99 0 0 1-.424-.812c0-.296.138-.577.379-.772.375-.304.48-.833.249-1.257a1 1 0 0 1-.128-.471c0-.537.427-.978.959-.999.48.02.967-.301 1.074-.775a1.24 1.24 0 0 1 1.216-.976c.689 0 1.25.561 1.25 1.25zm14.576 4.812a1 1 0 0 0-.249 1.377 1.001 1.001 0 0 1-.788 1.56 1.024 1.024 0 0 0-1.074.776 1.24 1.24 0 0 1-1.216.975c-.689 0-1.25-.561-1.25-1.25v-8.25c0-.689.561-1.25 1.25-1.25a1.24 1.24 0 0 1 1.216.975 1 1 0 0 0 .975.781c.533.021 1.059.455 1.059.993a1 1 0 0 1-.128.471 1 1 0 0 0 .249 1.257 1 1 0 0 1 .379.772.99.99 0 0 1-.424.812z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ear-muffs_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEarMuffs;
